import { TAG_NAME } from '../constants/TagNameConstants';

export const IMAGE_DIMENSIONS = {
  480: {
    banner: [480, 270],
    playerPoster: [480, 270],
    subscriptionBanner: [360, 202],
    showDetail: [480, 193],
    continueWatching: [224, 336],
    episodes: [734, 413],
    listBig: [429, 241],
    liveNews: [429, 241],
    liveTitleBig: [448, 252],
    liveTitleSmall: [238, 134],
    playlistBig: [764, 430],
    playlistSmall: [180, 101],
    liveVodBig: [764, 430],
    liveVodSmall: [320, 180],
    portraitSmall: [224, 336],
    top10: [224, 336],
    portraitLarge: [224, 336],
    title: [352, 198],
    sameepisodelist: [352, 198],
    differentepisodelist: [352, 198],
    collection: [366, 366],
    newsCollection: [188, 106],
    newsTitle: [734, 413],
    channels: [352, 198],
    upcoming: [180, 270],
    plexWidget: [396, 223],
    bellyUnitSingleCard: [204, 115],
    tvodCard: [168, 253],
    comboPackBanner: [480, 270],
    portraitSmallBg: [76, 114],
    zee5MusicEntrypointBanner: [448, 82],
    [TAG_NAME.SUBS_BANNER]: [360, 180],
    [TAG_NAME.SUBS_OFFER]: [328, 72],
    [TAG_NAME.FEATURE_ICON]: [0, 24],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 50],
    tournamentTeams: [148, 220]
  },
  599: {
    banner: [599, 337],
    playerPoster: [599, 337],
    subscriptionBanner: [360, 202],
    showDetail: [599, 240],
    continueWatching: [504, 756],
    episodes: [1082, 609],
    listBig: [541, 304],
    liveNews: [541, 304],
    liveTitleBig: [567, 319],
    liveTitleSmall: [238, 134],
    playlistBig: [1134, 638],
    playlistSmall: [270, 152],
    liveVodBig: [1134, 638],
    liveVodSmall: [476, 268],
    portraitSmall: [504, 756],
    top10: [504, 756],
    portraitLarge: [504, 756],
    title: [522, 294],
    sameepisodelist: [522, 294],
    differentepisodelist: [522, 294],
    collection: [366, 366],
    newsCollection: [238, 134],
    newsTitle: [1082, 609],
    channels: [522, 294],
    upcoming: [180, 270],
    plexWidget: [499, 281],
    bellyUnitSingleCard: [204, 115],
    tvodCard: [212, 319],
    comboPackBanner: [599, 337],
    portraitSmallBg: [100, 150],
    zee5MusicEntrypointBanner: [567, 104],
    [TAG_NAME.SUBS_BANNER]: [600, 300],
    [TAG_NAME.SUBS_OFFER]: [482, 72],
    [TAG_NAME.FEATURE_ICON]: [0, 24],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 50],
    tournamentTeams: [187, 281]
  },
  899: {
    banner: [899, 506],
    playerPoster: [899, 506],
    subscriptionBanner: [619, 348],
    showDetail: [899, 361],
    continueWatching: [504, 756],
    episodes: [856, 482],
    liveNews: [815, 458],
    listBig: [815, 458],
    liveTitleBig: [867, 488],
    liveTitleSmall: [401, 226],
    playlistBig: [1734, 975],
    playlistSmall: [408, 230],
    liveVodBig: [1572, 884],
    liveVodSmall: [502, 282],
    portraitSmall: [504, 756],
    top10: [504, 756],
    portraitLarge: [504, 756],
    title: [798, 449],
    sameepisodelist: [798, 449],
    differentepisodelist: [798, 449],
    collection: [406, 406],
    newsCollection: [364, 205],
    newsTitle: [856, 482],
    channels: [798, 449],
    upcoming: [134, 200],
    plexWidget: [300, 169],
    bellyUnitSingleCard: [238, 134],
    tvodCard: [325, 487],
    comboPackBanner: [899, 506],
    portraitSmallBg: [160, 240],
    zee5MusicEntrypointBanner: [867, 158],
    [TAG_NAME.SUBS_BANNER]: [900, 450],
    [TAG_NAME.SUBS_OFFER]: [660, 90],
    [TAG_NAME.FEATURE_ICON]: [0, 24],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 70],
    tournamentTeams: [287, 430]
  },
  1199: {
    banner: [1199, 480],
    playerPoster: [1199, 675],
    subscriptionBanner: [427, 240],
    showDetail: [1199, 451],
    continueWatching: [224, 336],
    episodes: [716, 403],
    listBig: [716, 403],
    liveNews: [716, 403],
    liveTitleBig: [1167, 656],
    liveTitleSmall: [329, 185],
    playlistBig: [1167, 656],
    playlistSmall: [269, 202],
    liveVodBig: [1051, 591],
    liveVodSmall: [334, 188],
    portraitSmall: [224, 336],
    top10: [224, 336],
    portraitLarge: [224, 336],
    title: [350, 197],
    sameepisodelist: [350, 197],
    differentepisodelist: [350, 197],
    collection: [204, 204],
    newsCollection: [242, 136],
    newsTitle: [716, 403],
    channels: [350, 197],
    upcoming: [227, 341],
    plexWidget: [470, 264],
    bellyUnitSingleCard: [427, 240],
    tvodCard: [218, 328],
    comboPackBanner: [880, 495],
    portraitSmallBg: [220, 330],
    zee5MusicEntrypointBanner: [1167, 213],
    [TAG_NAME.SUBS_BANNER]: [900, 712],
    [TAG_NAME.SUBS_OFFER]: [660, 90],
    [TAG_NAME.FEATURE_ICON]: [0, 24],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 70],
    tournamentTeams: [190, 286]
  },
  1366: {
    banner: [1013, 405],
    playerPoster: [821, 462],
    subscriptionBanner: [538, 302],
    showDetail: [1366, 548],
    continueWatching: [195, 293],
    episodes: [382, 215],
    listBig: [382, 215],
    liveNews: [382, 215],
    liveTitleBig: [965, 543],
    liveTitleSmall: [374, 210],
    playlistBig: [965, 543],
    playlistSmall: [321, 180],
    liveVodBig: [569, 320],
    liveVodSmall: [180, 101],
    portraitSmall: [195, 293],
    top10: [195, 293],
    portraitLarge: [195, 293],
    title: [223, 125],
    sameepisodelist: [223, 125],
    differentepisodelist: [223, 125],
    collection: [102, 102],
    newsCollection: [235, 132],
    newsTitle: [382, 215],
    channels: [223, 125],
    upcoming: [298, 447],
    plexWidget: [545, 307],
    bellyUnitSingleCard: [780, 439],
    tvodCard: [215, 323],
    comboPackBanner: [420, 238],
    portraitSmallBg: [150, 225],
    zee5MusicEntrypointBanner: [1286, 236],
    [TAG_NAME.SUBS_BANNER]: [750, 1042],
    [TAG_NAME.SUBS_OFFER]: [512, 90],
    [TAG_NAME.FEATURE_ICON]: [0, 36],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 70],
    tournamentTeams: [201, 302]
  },
  1600: {
    banner: [1188, 475],
    playerPoster: [972, 546],
    subscriptionBanner: [538, 302],
    showDetail: [1600, 642],
    continueWatching: [231, 347],
    episodes: [451, 254],
    listBig: [451, 254],
    liveNews: [451, 254],
    liveTitleBig: [1136, 639],
    liveTitleSmall: [215, 121],
    playlistBig: [1136, 639],
    playlistSmall: [384, 216],
    liveVodBig: [676, 380],
    liveVodSmall: [234, 131],
    portraitSmall: [231, 347],
    top10: [231, 347],
    portraitLarge: [231, 347],
    title: [264, 149],
    sameepisodelist: [264, 149],
    differentepisodelist: [264, 149],
    collection: [125, 125],
    newsCollection: [277, 156],
    newsTitle: [451, 254],
    channels: [264, 149],
    upcoming: [298, 447],
    plexWidget: [643, 362],
    bellyUnitSingleCard: [780, 439],
    tvodCard: [252, 378],
    comboPackBanner: [420, 238],
    portraitSmallBg: [205, 308],
    zee5MusicEntrypointBanner: [1719, 315],
    [TAG_NAME.SUBS_BANNER]: [750, 1042],
    [TAG_NAME.SUBS_OFFER]: [512, 90],
    [TAG_NAME.FEATURE_ICON]: [0, 36],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 70],
    tournamentTeams: [272, 409]
  },
  7680: {
    banner: [1420, 569],
    playerPoster: [1117, 628],
    subscriptionBanner: [540, 304],
    showDetail: [1920, 770],
    continueWatching: [321, 482],
    episodes: [502, 282],
    listBig: [502, 282],
    liveNews: [502, 282],
    liveTitleBig: [1239, 697],
    liveTitleSmall: [407, 229],
    playlistBig: [1239, 697],
    playlistSmall: [321, 241],
    liveVodBig: [731, 411],
    liveVodSmall: [234, 131],
    portraitSmall: [321, 482],
    top10: [321, 482],
    portraitLarge: [321, 482],
    title: [407, 229],
    sameepisodelist: [407, 229],
    differentepisodelist: [407, 229],
    collection: [265, 265],
    newsCollection: [346, 194],
    newsTitle: [502, 282],
    channels: [407, 229],
    upcoming: [320, 480],
    plexWidget: [508, 286],
    bellyUnitSingleCard: [780, 439],
    tvodCard: [298, 438],
    comboPackBanner: [420, 238],
    portraitSmallBg: [140, 210],
    zee5MusicEntrypointBanner: [1840, 340],
    [TAG_NAME.SUBS_BANNER]: [750, 1042],
    [TAG_NAME.SUBS_OFFER]: [512, 90],
    [TAG_NAME.FEATURE_ICON]: [0, 36],
    [TAG_NAME.SUBS_FEATURE_ICON]: [0, 70],
    tournamentTeams: [293, 440]
  }
};

const imageDimensions: Readonly<typeof IMAGE_DIMENSIONS> =
  Object.freeze(IMAGE_DIMENSIONS);

/**
 *
 * @param resolution: device width
 * @returns match width with nearby supported resolution and return it.
 */
export const getImagesDimentionByResolution = (resolution: number) => {
  let imageDimension;
  if (resolution < 481) {
    imageDimension = imageDimensions[480];
  } else if (resolution < 600) {
    imageDimension = imageDimensions[599];
  } else if (resolution < 900) {
    imageDimension = imageDimensions[899];
  } else if (resolution < 1200) {
    imageDimension = imageDimensions[1199];
  } else if (resolution < 1367) {
    imageDimension = imageDimensions[1366];
  } else if (resolution < 1601) {
    imageDimension = imageDimensions[1600];
  } else {
    imageDimension = imageDimensions[7680];
  }
  return imageDimension;
};
